import React from 'react';
import { XIcon } from 'lucide-react';
import { problemas } from '../data/problemas';
import { Emoji } from './Emoji';
export function Problema() {
  return <section className="w-full bg-white pb-14 pt-14 sm:pb-16 sm:pt-16" data-id="element-186" data-mp="2cwh6o8vzuiwy">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[760px]" data-id="element-187" data-mp="2rp14qv4ae07j">
        <h2 className="font-display text-[clamp(1.5rem,5.5vw,2.5rem)] font-extrabold leading-[1.08] tracking-tight text-ink-900" data-id="element-188" data-mp="2mvyaekroqmqa">
          ¿Cuántos domingos más vas a terminar sin saber qué comer mañana?
        </h2>

        <p className="mt-4 font-display text-lg font-bold text-red-600 sm:text-xl" data-id="element-189" data-mp="2wm9qt6sk2oe2">
          No terminás nunca.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-ink-500 sm:text-lg" data-id="element-190" data-mp="35n7utp2zuvwn">
          Y lo peor no es el hambre… es esa sensación de que querés comer bien,
          comer con proteína, organizarte, y salir del ciclo… pero la semana te
          vuelve a ganar siempre.
        </p>
        <p className="mt-6 font-display text-lg font-extrabold text-celeste-700 sm:text-2xl" data-id="element-191" data-mp="37pc6upbo4lz4">
          No es falta de ganas. No es falta de recetas. Es falta de un sistema.
        </p>

        <p className="mt-10 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-ink-400 sm:text-sm" data-id="element-192" data-mp="3cm2mjbjk9fk0">
          ¿Te reconocés en alguna de estas situaciones?
        </p>

        <ul className="mt-6 flex flex-col gap-3 text-left" data-id="element-193" data-mp="3liv68dknvenc">
          {problemas.map(problema => <li key={problema} className="flex items-center gap-3 rounded-xl border border-red-200 bg-red-100 px-4 py-3.5 sm:gap-4 sm:px-5 sm:py-4" data-id="element-194" data-mp="3qhy4nf64ymmc">
              <XIcon className="h-5 w-5 shrink-0 text-red-600 sm:h-6 sm:w-6" strokeWidth={3.5} aria-hidden="true" data-id="element-195" data-mp="46iziu9hgtde" />
              <span className="font-display text-[14px] font-bold leading-snug text-ink-900 sm:text-[15px]" data-id="element-196" data-mp="261bgsedqpw76">
                {problema}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-[14px] leading-relaxed text-ink-500 sm:text-[15px]" data-id="element-197" data-mp="3ddaoynpzzy1q">
          Si te reconociste en aunque sea una de estas, lo que vas a leer ahora
          te cambia la semana para siempre.
        </p>

        <p className="mt-8 font-display text-[clamp(1.25rem,5vw,1.875rem)] font-extrabold italic tracking-tight text-celeste-600" data-id="element-198" data-mp="3maurs13ie2eg">
          ¿Y si este fuera el último domingo que pasás así?
        </p>

        <p className="mx-auto mt-6 inline-flex max-w-full flex-wrap items-center justify-center gap-2 rounded-full border border-gold-400 bg-gold-100 px-4 py-2 font-display text-[10px] font-extrabold uppercase tracking-[0.12em] text-gold-800 sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-199" data-mp="3rcabnptya2v9">
          <Emoji symbol="⭐" data-id="element-200" data-mp="4xheapiclgsl" />
          Close The Gap™ — MegaPack Cocina Proteica Lista
        </p>
      </div>
    </section>;
}